import ResidentHistoryTemplate from "app/features/residents/templates/view/ResidentHistoryTemplate";

export default function HistoryScreen() {
  return <ResidentHistoryTemplate />;
}
